import _slicedToArray from "/Users/vintharas/GitHub/barbarianmeetscoding/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/Users/vintharas/GitHub/barbarianmeetscoding/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/vintharas/GitHub/barbarianmeetscoding/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/Users/vintharas/GitHub/barbarianmeetscoding/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/Users/vintharas/GitHub/barbarianmeetscoding/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/Users/vintharas/GitHub/barbarianmeetscoding/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/vintharas/GitHub/barbarianmeetscoding/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import Backend from "./backend.js";
import * as Color from "../color.js";
function clearToAnsi(bg) {
  return "\x1B[0;48;5;".concat(termcolor(bg), "m\x1B[2J");
}
function colorToAnsi(fg, bg) {
  return "\x1B[0;38;5;".concat(termcolor(fg), ";48;5;").concat(termcolor(bg), "m");
}
function positionToAnsi(x, y) {
  return "\x1B[".concat(y + 1, ";").concat(x + 1, "H");
}
function termcolor(color) {
  var SRC_COLORS = 256.0;
  var DST_COLORS = 6.0;
  var COLOR_RATIO = DST_COLORS / SRC_COLORS;
  var rgb = Color.fromString(color);
  var r = Math.floor(rgb[0] * COLOR_RATIO);
  var g = Math.floor(rgb[1] * COLOR_RATIO);
  var b = Math.floor(rgb[2] * COLOR_RATIO);
  return r * 36 + g * 6 + b * 1 + 16;
}
var Term = /*#__PURE__*/function (_Backend) {
  _inherits(Term, _Backend);
  var _super = _createSuper(Term);
  function Term() {
    var _this;
    _classCallCheck(this, Term);
    _this = _super.call(this);
    _this._offset = [0, 0];
    _this._cursor = [-1, -1];
    _this._lastColor = "";
    return _this;
  }
  _createClass(Term, [{
    key: "schedule",
    value: function schedule(cb) {
      setTimeout(cb, 1000 / 60);
    }
  }, {
    key: "setOptions",
    value: function setOptions(options) {
      _get(_getPrototypeOf(Term.prototype), "setOptions", this).call(this, options);
      var size = [options.width, options.height];
      var avail = this.computeSize();
      this._offset = avail.map(function (val, index) {
        return Math.floor((val - size[index]) / 2);
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      process.stdout.write(clearToAnsi(this._options.bg));
    }
  }, {
    key: "draw",
    value: function draw(data, clearBefore) {
      // determine where to draw what with what colors
      var _data = _slicedToArray(data, 5),
        x = _data[0],
        y = _data[1],
        ch = _data[2],
        fg = _data[3],
        bg = _data[4];
      // determine if we need to move the terminal cursor
      var dx = this._offset[0] + x;
      var dy = this._offset[1] + y;
      var size = this.computeSize();
      if (dx < 0 || dx >= size[0]) {
        return;
      }
      if (dy < 0 || dy >= size[1]) {
        return;
      }
      if (dx !== this._cursor[0] || dy !== this._cursor[1]) {
        process.stdout.write(positionToAnsi(dx, dy));
        this._cursor[0] = dx;
        this._cursor[1] = dy;
      }
      // terminals automatically clear, but if we're clearing when we're
      // not otherwise provided with a character, just use a space instead
      if (clearBefore) {
        if (!ch) {
          ch = " ";
        }
      }
      // if we're not clearing and not provided with a character, do nothing
      if (!ch) {
        return;
      }
      // determine if we need to change colors
      var newColor = colorToAnsi(fg, bg);
      if (newColor !== this._lastColor) {
        process.stdout.write(newColor);
        this._lastColor = newColor;
      }
      if (ch != '\t') {
        // write the provided symbol to the display
        var chars = [].concat(ch);
        process.stdout.write(chars[0]);
      }
      // update our position, given that we wrote a character
      this._cursor[0]++;
      if (this._cursor[0] >= size[0]) {
        this._cursor[0] = 0;
        this._cursor[1]++;
      }
    }
  }, {
    key: "computeFontSize",
    value: function computeFontSize() {
      throw new Error("Terminal backend has no notion of font size");
    }
  }, {
    key: "eventToPosition",
    value: function eventToPosition(x, y) {
      return [x, y];
    }
  }, {
    key: "computeSize",
    value: function computeSize() {
      return [process.stdout.columns, process.stdout.rows];
    }
  }]);
  return Term;
}(Backend);
export { Term as default };